/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedsusworkshoplearningtolearn6Inputs */

const de__field_participatedsusworkshoplearningtolearn6 = /** @type {(inputs: _Field_Participatedsusworkshoplearningtolearn6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen an SuS-Workshop Learning To Learn`)
};

/**

* @param {_Field_Participatedsusworkshoplearningtolearn6Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedsusworkshoplearningtolearn6 = /** @type {((inputs?: _Field_Participatedsusworkshoplearningtolearn6Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedsusworkshoplearningtolearn6Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_participatedsusworkshoplearningtolearn6(inputs)
});
export { _field_participatedsusworkshoplearningtolearn6 as "_field_participatedSuSWorkshopLearningToLearn" }